export const removeRemoteVideo = (removeAudio = true) => {
    try {
        const previewContainer = document.getElementsByClassName('remote-video')[0]
        if (previewContainer) {
            for (let i = 0; i < previewContainer.children.length; i++) {
                const currentElem = previewContainer.children[i]
                if (removeAudio || (currentElem.localName !== 'audio' && !removeAudio)) {
                    // do not remove audio track if not needed
                    previewContainer.removeChild(currentElem)
                }
            }
        }
    } catch (e) {
        console.log('[TWILIOUTILS-removeRemoteVideo] there was an error when removeChild')
    }
}

export const removeLocaleVideo = () => {
    try {
        const localContainer = document.getElementsByClassName('locale-video')[0]
        if (localContainer) {
            while (localContainer.firstChild) {
                localContainer.removeChild(localContainer.firstChild)
            }
        }
    } catch (e) {
        console.log('[TWILIOUTILS-removeLocaleVideo] there was an error when removeChild')
    }
}

export const isDevicePresent = (devices: any, id: any) => {
    const device = devices.find((element: any) => element.deviceId === id)
    return !!device
}
